import { render, staticRenderFns } from "./UpdateIdentityUserDialog.vue?vue&type=template&id=4bd5abc6"
import script from "./UpdateIdentityUserDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpdateIdentityUserDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/children/identityUsers/locales/i18n-identity-user-dialogs.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2Fchildren%2FidentityUsers%2FUpdateIdentityUserDialog.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports